import script from "./CheckoutCustomization.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckoutCustomization.vue?vue&type=script&setup=true&lang=js"

import "./CheckoutCustomization.vue?vue&type=style&index=0&id=05e824a2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05e824a2"]])

export default __exports__